import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionHelper } from '../../helpers/permission.helper';
import { ProductElement } from '../../models/product-element.model';
import { Product } from '../../models/product.model';

@Component({
  standalone: false,
  selector: 'app-product-segment',
  templateUrl: './product-segment.component.html',
})
export class ProductSegmentComponent implements OnInit {
  @Input() parentProduct: Product;
  @Input() productElements: Array<ProductElement>;
  @Input() fullParentIndex: string;
  @Input() parentId: number | undefined;
  @Input() isTopLevelProduct: boolean;

  // @Output() readonly productElementAdded = new EventEmitter();
  @Output() readonly productElementEdited = new EventEmitter();
  @Output() readonly productElementDeleted = new EventEmitter();

  constructor(private router: Router, public permissionHelper: PermissionHelper) {}

  ngOnInit(): void {}

  getExpandedProductPartIds(): Array<number> {
    return JSON.parse(localStorage.getItem('expandedProductIds')) || [];
  }

  // Going through the list of products and find all the product childs from current shown product (which is parent)
  getProductsFilteredByParentId(): Array<ProductElement> {
    return this.productElements?.filter(product => {
        return product.parentProductPartId === this.parentId;
      }) || []
  }

  isProductExpanded(productPartId: number): boolean {
    const expandedProductIds = this.getExpandedProductPartIds();
    return expandedProductIds.some(productId => productId === productPartId);
  }

  isNotMaterial(product: ProductElement): boolean {
    return product.productClass === 'semiProduct' || product.productClass === 'finishedProduct';
  }

  hasChildren(product: ProductElement): boolean {
    return this.productElements.some(item => item.parentProductPartId === product.productPartId);
  }

  getChildElements(product: ProductElement): void {
    if (this.isNotMaterial(product)) {
      this.storeExpandedProductIdInLocalStorage(product.productPartId, !this.isProductExpanded(product.productPartId));
    }
  }

  // Store all the products that are expanded in localStorage because we want to save all expanded products when refresh page/go to some other product
  storeExpandedProductIdInLocalStorage(productPartId: number, isExpanded: boolean): void {
    let expandedProductIds = this.getExpandedProductPartIds();

    const isAlreadyInExpandedProductsAray = expandedProductIds.some(productId => productId === productPartId);

    if (isExpanded && !isAlreadyInExpandedProductsAray) {
      expandedProductIds.push(productPartId);
    } else if (!isExpanded && isAlreadyInExpandedProductsAray) {
      expandedProductIds = expandedProductIds.filter(productId => productId !== productPartId);
    }

    localStorage.setItem('expandedProductIds', JSON.stringify(expandedProductIds));
  }

  goToProductDevelopmentPage(product: ProductElement): void {
    let url;
    if (!product.isGhost) {
      if (product.level > 0 && (product.productClass === 'semiProduct' || product.productClass === 'finishedProduct')) {
        url = this.router.serializeUrl(this.router.createUrlTree([`/product/details/${product.productId}/development`]));
      }
    } else {
      url = this.router.serializeUrl(this.router.createUrlTree([`/product/details/${product.productId}/operation`]));
    }
    window.open(url, '_blank');
  }

  unselectNotChosenProducts(product: ProductElement): void {
    this.productElements.filter(p => p.productPartId !== product.productPartId).forEach(el => (el.isSelected = false));
  }

  // onAddProductElement(product: ProductElement): void {
  //   product.isSelected = true;
  //   this.unselectNotChosenProducts(product);
  //   this.productElementAdded.emit(product);
  // }

  onEditProductElement(product: ProductElement): void {
    product.isSelected = true;
    this.unselectNotChosenProducts(product);
    this.productElementEdited.emit(product);
  }

  onDeleteProductElement(product: ProductElement): void {
    this.productElementDeleted.emit(product);
  }
}
